import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { TokenStorageService } from '../auth/token-storage.service';
import { RouterConstants } from '../_models/router-constants';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-pairing',
  templateUrl: './pairing.component.html',
  styleUrls: ['./pairing.component.scss']
})
export class PairingComponent implements OnInit {

  pairingCode: string | null = null;

  constructor(private router: Router, private authService: AuthService, private tokenStorageService: TokenStorageService) {
    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      this.router.navigate(['/'], {replaceUrl: true});
    }

    // redirect to login, show ovis login page
    if (this.tokenStorageService.getPairedLoginToken() != null) {
      this.router.navigate(['/' + RouterConstants.LOGIN], {replaceUrl: true});
    }
  }

  ngOnInit(): void {
  }

  onPair(): void {
    if (this.pairingCode != null) {
      this.authService.pairDevice(this.pairingCode)
        .pipe(first())
        .subscribe({
          next: () => {
            // show ovis login felület
            this.router.navigate(['/' + RouterConstants.LOGIN], {replaceUrl: true});
          }
        });
    }
  }
}
